import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { makeDecodeError } from '@infl-ts/util-make-apollo-decoded';
import { isValidUrl } from '@infl-ts/util-url';
import PublishIcon from '@mui/icons-material/Publish';
import { Box, TextField } from '@mui/material';
import { Filestack } from 'filestack-js';
import * as E from 'fp-ts/Either';
import { absurd, flow } from 'fp-ts/function';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FILESTACK_API_KEY } from '../../env';
import { AsyncButton } from '../async-button';
import { UploadedFileFromUrl } from './codecs';
import { fileTypeExt, imageTypeExt, imageTypes, uniqTypesFromExts, videoTypeExt, videoTypes } from './file-type-white-list';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var getFileFromUrl = function getFileFromUrl(_ref) {
  var sourceUrl = _ref.sourceUrl,
      onSuccess = _ref.onSuccess,
      onError = _ref.onError,
      clientOptions = _ref.clientOptions,
      storeParams = _ref.storeParams,
      acceptedFormat = _ref.acceptedFormat,
      acceptedFormatText = _ref.acceptedFormatText,
      setLoadingState = _ref.setLoadingState,
      acceptedMediaType = _ref.acceptedMediaType,
      t = _ref.t;

  if (sourceUrl && isValidUrl(sourceUrl)) {
    void Filestack(FILESTACK_API_KEY, clientOptions).storeURL(sourceUrl, storeParams).then(flow(function (response) {
      return UploadedFileFromUrl.decode(response);
    }, E.mapLeft(makeDecodeError), E.match(function () {
      return onError(t('Could not upload this file'));
    }, function (file) {
      if (acceptedFormat.includes(file.mimetype)) {
        onSuccess(_objectSpread(_objectSpread({}, file), {}, {
          mediaType: acceptedMediaType
        }));
        setLoadingState('success');
      } else {
        onError(t('Please upload a supported filetype: {{fileTypes}}', {
          fileTypes: acceptedFormatText.join(' ')
        }));
        setLoadingState('error');
      }
    })))["catch"](function () {
      return onError(t('Please ensure that you provided a valid url'));
    });
  } else {
    setLoadingState('error');
    onError(t('Please ensure that you provided a valid url'));
  }
};

export var UploadFromUrl = function UploadFromUrl(_ref2) {
  var _infl;

  var onSuccess = _ref2.onSuccess,
      onError = _ref2.onError,
      clientOptions = _ref2.clientOptions,
      storeParams = _ref2.storeParams,
      error = _ref2.error,
      acceptedMediaType = _ref2.acceptedMediaType;

  var _useState = useState(null),
      sourceUrl = _useState[0],
      setSourceUrl = _useState[1];

  var _useState2 = useState('default'),
      loadingState = _useState2[0],
      setLoadingState = _useState2[1];

  var enabledExtensions = (_infl = window._infl) === null || _infl === void 0 ? void 0 : _infl.enabledExtensionsForFileUpload;
  var acceptedFormat = acceptedMediaType === 'video' ? videoTypes : acceptedMediaType === 'image' ? imageTypes : acceptedMediaType === 'file' ? uniqTypesFromExts(enabledExtensions || fileTypeExt) : absurd(acceptedMediaType);
  var acceptedFormatText = acceptedMediaType === 'video' ? videoTypeExt : acceptedMediaType === 'image' ? imageTypeExt : acceptedMediaType === 'file' ? enabledExtensions || fileTypeExt : absurd(acceptedMediaType);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      display: 'flex'
    },
    "data-element": "Box",
    "data-component": "UploadFromUrl",
    "data-source-file": "upload-from-url.tsx",
    children: [/*#__PURE__*/_jsx(TextField, {
      sx: {
        flexGrow: 3,
        mr: 1
      },
      onChange: function onChange(event) {
        return setSourceUrl(event.target.value);
      },
      autoFocus: true,
      error: error,
      id: "outlined-error",
      label: t('Enter file URL'),
      "data-element": "TextField",
      "data-component": "UploadFromUrl",
      "data-source-file": "upload-from-url.tsx"
    }), /*#__PURE__*/_jsx(AsyncButton, {
      status: loadingState,
      onClick: function onClick() {
        setLoadingState('saving');
        getFileFromUrl({
          sourceUrl: sourceUrl,
          onSuccess: onSuccess,
          onError: onError,
          acceptedFormat: acceptedFormat,
          acceptedFormatText: acceptedFormatText,
          setLoadingState: setLoadingState,
          clientOptions: clientOptions,
          storeParams: storeParams,
          acceptedMediaType: acceptedMediaType,
          t: t
        });
      },
      text: [t('Uploading...'), t('Uploaded'), t('Upload'), t('Upload')],
      startIcon: loadingState === 'default' && /*#__PURE__*/_jsx(PublishIcon, {
        fontSize: "large"
      }),
      "data-element": "AsyncButton",
      "data-source-file": "upload-from-url.tsx"
    })]
  });
};